module.exports = __webpack_public_path__ + "img/f883668eb4ec32a0a66c70a734b8582f.svg";